class ImageComparison extends HTMLElement {
  connectedCallback() {
    this.dragging = false;
    this.handle = this.querySelector('.ic__handle');

    if (!this.handle) return;

    this.handle.addEventListener('pointerdown', this.start.bind(this));

    window.addEventListener('pointermove', this.move.bind(this));
    window.addEventListener('pointerup', this.end.bind(this));
    window.addEventListener('pointercancel', this.end.bind(this));
  }

  start(event) {
    this.dragging = true;
    this.classList.add('is-dragging');
    this.handle.setPointerCapture(event.pointerId);
    this.update(event);
  }

  end(event) {
    if (!this.dragging) return;

    this.dragging = false;
    this.classList.remove('is-dragging');

    try {
      this.handle.releasePointerCapture(event.pointerId);
    } catch(e) {}
  }

  move(event) {
    if (!this.dragging) return;

    this.update(event);
  }

  update(event) {
    const rect = this.getBoundingClientRect();
    let percent;

    if (this.dataset.layout === 'vertical') {
      percent = ((event.clientY - rect.top) / rect.height) * 100;
    } else {
      percent = ((event.clientX - rect.left) / rect.width) * 100;
    }

    percent = Math.max(0, Math.min(100, percent));

    this.style.setProperty('--ic-position', percent + '%');
    this.handle.setAttribute('aria-valuenow', Math.round(percent));
  }
}

if (!customElements.get('image-comparison')) {
  customElements.define('image-comparison', ImageComparison);
}